module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/tag-1131970eb712e71e59354255bfe8eb6d.svg";